const farmsModel = {
  myNftFrams: () => import("@/common/popupBottom/FramModel/myNftFrams"),
  sellNftsFrame: () => import("@/common/popupBottom/FramModel/sellNftsFrame"),
  dealingsFrame: () => import("@/common/popupBottom/FramModel/dealingsFrame"),
  minesNftFrame: () => import("@/common/popupBottom/FramModel/minesNftFrame"),
  goodsFrames: () => import("@/common/popupBottom/FramModel/goodsFrames"),
  myOrderFarme: () => import("@/common/popupBottom/FramModel/myOrderFarme"),
  myLockerOrdeFrame: () => import("@/common/popupBottom/FramModel/myLockerOrdeFrame"),
  selectAddressFrame: () => import("@/common/popupBottom/FramModel/selectAddressFrame"),
  DealingsNftFrame: () => import("@/common/popupBottom/FramModel/DealingsNftFrame"),
  MyGoodsFarme: () => import("@/common/popupBottom/FramModel/MyGoodsFarme"),
};
export default farmsModel;
